interface IHowItWorks {
    title: string;
    subtitle: string;
}

export const howItWorksData: IHowItWorks[] = [
    {
        title: "rewards_modal.main_screen.how_it_works.data.item1.title",
        subtitle: "rewards_modal.main_screen.how_it_works.data.item1.subtitle",
    },
    {
        title: "rewards_modal.main_screen.how_it_works.data.item2.title",
        subtitle: "rewards_modal.main_screen.how_it_works.data.item2.subtitle",
    },
    {
        title: "rewards_modal.main_screen.how_it_works.data.item3.title",
        subtitle: "rewards_modal.main_screen.how_it_works.data.item3.subtitle",
    },
];
